import { createContext } from "react";

type Theme = "dark" | "light" | "system";

type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialState: ThemeProviderState = {
  theme: "light",
  setTheme: () => null,
  collapsed: false,
  setCollapsed: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
